// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3D24M","requiredAsterisk":"Info_requiredAsterisk__23rcA"};